import gsap from 'gsap';

export const DEFAULT_CONFIG = {
  duration: 0.6,
  delay: 0
};

export const start = (xAniConfig, scope) => {
  const tweenList = [];
  const ctx = gsap.context(() => {
    for (const label in xAniConfig) {
      tweenList.push(gsap.from(`[data-x-ani-label="${label}"]`, xAniConfig[label]));
    }
  }, scope);
  return {
    ctx,
    restart() {
      tweenList.forEach(tween => tween.restart(true));
    },
    reverse() {
      tweenList.forEach(tween => tween.reverse());
    },
    reset() {
      tweenList.forEach(tween => tween.progress(0).pause());
    }
  };
};

export const startTimeline = (xAniConfig, scope) => {
  const timeline = gsap.timeline({
    defaults: DEFAULT_CONFIG
  });
  const ctx = gsap.context(() => {
    for (const label in xAniConfig) {
      timeline.from(`[data-x-ani-label="${label}"]`, xAniConfig[label]);
    }
  }, scope);
  return {
    ctx,
    timeline,
    restart() {
      timeline.restart(true);
    },
    reverse() {
      timeline.reverse();
    },
    reset() {
      timeline.progress(0).pause();
    }
  };
};
